import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import Map from 'ol/Map';
import { View } from 'ol';
import Overlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import FullScreen from 'ol/control/FullScreen.js';
import {defaults as defaultControls} from 'ol/control';
import { Point, Polygon, LineString } from 'ol/geom';
import * as layer from 'ol/layer';
import { Tile as Tile, Vector as VectorLayer, Image as ImageLayer } from 'ol/layer';
import { OSM as OSM, Vector as VectorSource, Vector as MeasureSource } from 'ol/source';
import { WFS, GeoJSON } from 'ol/format';
import ImageWMS from 'ol/source/ImageWMS';
import { Icon, Style, Fill, Stroke } from 'ol/style';
import * as control from 'ol/control';
import * as proj from 'ol/proj';
import { ApiService } from '../service/api.service';
import { environment } from 'src/environments/environment.prod';

const baseUrlFile = environment.FILE_API_URL;


@Component({
  selector: 'app-apomap',
  templateUrl: './apomap.component.html',
  styleUrls: ['./apomap.component.css']
})
export class ApomapComponent implements AfterViewInit,OnChanges {
  @Input() mapinfo: any[]=[];
  //@Input() kmlinfo:any;
  private olMap: Map | null = null;
  imegary: any;
  streetmap: any;
  private vectorSource: VectorSource | null = null;
  private popup: Overlay | null = null;
  private gpsCoordinates: { lat: number, lng: number, properties: any }[] = [];
    private latestMapInfo: any[] = []; // Store the latest mapinfo

  constructor(private cdr: ChangeDetectorRef,
    private apiService: ApiService
  ) {
    
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.initiatemap(), 100);
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mapinfo']) {
      // Store the latest mapinfo value
      this.latestMapInfo = changes['mapinfo'].currentValue || [];
      // Only call updateMap if olMap is already initialized
      if (this.olMap) {
        this.updateMap();
      }
    }
  }
  initiatemap():void{
    this.imegary = new Tile({
      visible: true,
      source: new OSM({
        url: 'https://mt{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
         attributions: '' 
      })
    });
    this.streetmap = new Tile({
      visible: false,
      source: new OSM({
        url: 'https://mt{0-3}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
         attributions: '' 
      })
    });
  

    // State Boundary
    var _StateBoundary = new layer.Image({
      source: new ImageWMS({
        url: 'https://mapserver.odisha4kgeo.in/geoserver/iwlms/wms',
        params: {
          'FORMAT': 'image/png',
          'VERSION': '1.1.0',
          STYLES: '',
          LAYERS: 'iwlms:odisha_state_boundary'
        },
        serverType: 'geoserver',
        crossOrigin: 'anonymous'
      }),
      visible: true
    }); 

    try {
      this.vectorSource = new VectorSource();
      ////console.log(this.gpsCoordinates);
      // this.gpsCoordinates.forEach(coord => {
      //   if (!isNaN(coord.lat) && !isNaN(coord.lng)) {
      //     const feature = new Feature({
      //       geometry: new Point(proj.fromLonLat([coord.lng, coord.lat]))
      //     });
      //     feature.setProperties({ info: coord.properties });
      //     feature.setStyle(
      //       new Style({
      //         // image: new Icon({
      //         //   src: 'https://openlayers.org/en/latest/examples/data/icon.png',
      //         //   scale: 0.1
      //         // })
      //         image: new Icon({
      //           src: '../assets/images/mapmarker.png',
      //         }),
      //       })
      //     );
      //     this.vectorSource.addFeature(feature);
      //   }
      // });

      this.olMap = new Map({
        
        target: 'olmap',
        layers: [
          this.imegary,this.streetmap,_StateBoundary,
          new VectorLayer({
            source: this.vectorSource
          })
        ],
        view: new View({
          center: proj.fromLonLat([85.190055, 20.886785]),
         //center: proj.fromLonLat([this.gpsCoordinates[0].lng, this.gpsCoordinates[0].lat]),
          zoom: 6,
          maxZoom: 23,
          minZoom: 5,
          }),
           controls: defaultControls().extend([new FullScreen()]),
      });

      // Initialize popup overlay
      const popupElement = document.getElementById('popup');
      if (popupElement) {
        // this.popup = new Overlay({
        //   element: popupElement,
        //   positioning: 'bottom-center',
        //   stopEvent: false,
        //   offset: [0, -10]
        // });
                this.popup = new Overlay({
          element: popupElement,
          positioning: 'bottom-center',
          stopEvent: false,
          offset: [0, -10],
          autoPan: {
            animation: { duration: 250 },
            margin: 20
          }
        });
        this.olMap.addOverlay(this.popup);
      }

     



       // Pointermove event to change cursor on hover
    this.olMap.on('pointermove', (event) => {
      const pixel = event.pixel;
      const feature = this.olMap!.forEachFeatureAtPixel(pixel, (feat) => feat, {
        hitTolerance: 15 // Match the click tolerance
      });

      // Change cursor to pointer if a feature is found, otherwise revert to default
      const mapElement = this.olMap!.getTargetElement();
      mapElement.style.cursor = feature ? 'pointer' : 'auto';
    });
    this.olMap.on('click', (event) => {
        const pixel = event.pixel;
        const features: Feature[] = [];
        this.olMap!.forEachFeatureAtPixel(pixel, (feat) => {
          features.push(feat as Feature);
        }, { hitTolerance: 15 }); // Match hitTolerance with pointermove

        if (features.length > 0) {
          const feature = features[0];
          const geometry = feature.getGeometry();
          let coordinates: number[] | undefined;

          if (geometry instanceof Point) {
            const coordinates = (geometry as Point).getCoordinates();
          } else if (geometry instanceof Polygon) {
            // Use the centroid or the clicked coordinate for polygons
            coordinates = (geometry as Polygon).getInteriorPoint().getCoordinates();
          } else if (geometry instanceof LineString) {
            // Use the closest point on the line to the click
            coordinates = (geometry as LineString).getClosestPoint(event.coordinate);
          } else {
            //console.warn('Unsupported geometry type:', geometry?.getType());
            this.popup?.setPosition(undefined);
            return;
          }

          let properties: any = feature.getProperties();
          //console.log('Feature properties:', properties);   

          const params: string[] = [];
          if (properties.formId) params.push(`formId=${properties.formId}`);
          if (properties.componentId) params.push(`componentId=${properties.componentId}`);
          if (properties.apoId) params.push(`apoId=${properties.apoId}`);
          const queryString = params.join('&');

          //console.log(queryString)
          if(queryString){
               this.apiService.request('GET', `api/v1/APO/getAllApoMapDetails?${queryString}`).subscribe({
                    next: (response: any) => {
                      if (response.status === 1) {
                       //console.log("getAPOExecutionList",response);
                        properties = {...properties, ...response.data};
                        this.showPopup(coordinates!, properties, features);
                      } else {
                       // this.notifyService.showError("Error fetching filter options", "Error");
                       //console.warn('API response status not 1:', response);
                       this.showPopup(coordinates!, properties, features);
                      }
                    },
                    error: (error) => {
                     // console.error('API Error:', error);
                      // Show popup with existing properties as fallback
                      this.showPopup(coordinates!, properties, features);
                   }
              });
          }else {
            // No API call possible, show popup with existing properties
            //console.warn('No valid query parameters for API call');
            this.showPopup(coordinates, properties, features);
          }
        } else {
          this.popup?.setPosition(undefined);
        }
      });

      // Click handler for displaying popup
      // this.olMap.on('click', (event) => {
      //   if (!this.popup || !this.vectorSource) return;
      //   const feature = this.olMap.forEachFeatureAtPixel(event.pixel, (feat) => feat);
      //   if (feature) {
      //     const coordinates = (feature.getGeometry() as Point).getCoordinates();
      //     const properties = feature.getProperties().info;
      //     // const content = `
      //     //   <table>
      //     //     <tr><th>Task</th><td>${properties.taskName}</td></tr>
      //     //     <tr><th>Quantity</th><td>${properties.quantity}</td></tr>
      //     //     <tr><th>Unit Cost</th><td>${properties.unitCost}</td></tr>
      //     //     <tr><th>Amount Required</th><td>${properties.amountRequired}</td></tr>
      //     //     <tr><th>Location</th><td>${properties.location}</td></tr>
      //     //     <tr><th>Site</th><td>${properties.site}</td></tr>
      //     //   </table>
      //     // `;
      //     let content = `<table><tr><th>Task</th><td>${properties.taskName}</td></tr>`;
      //     if (properties.typeName) {
      //       content += `<tr><th>Type</th><td>${properties.typeName}</td></tr>`;
      //     }
      //     content += `<tr><th>Location</th><td>${properties.location}</td></tr>`;
      //     content += `</table>`;
      //     const popupContent = document.getElementById('popup-content');
      //     if (popupContent) {
      //       popupContent.innerHTML = content;
      //       this.popup.setPosition(coordinates);
      //     }
      //   } else {
      //     this.popup.setPosition(undefined);
      //   }
      // });
      // // Plot markers if mapinfo is available
      // if (this.mapinfo && this.mapinfo.length > 0) {
      //   this.updateMap();
      // }
      // Force map to update its size
      //this.olMap.updateSize();
       // Check if mapinfo has data and update the map
    if (this.latestMapInfo.length > 0) {
      this.updateMap();
    }
      ////console.log('OpenLayers Map initialized successfully:', this.olMap);
    } catch (error) {
      //console.error('Error initializing OpenLayers map:', error);
    }

 }
  resizeMap(): void {
    if (this.olMap) {
      setTimeout(() => {
        this.olMap!.updateSize();
      }, 200);
    }
  }
 private updateMap(): void {
  //console.log("this.latestMapInfo", this.latestMapInfo);
  if (!this.olMap || !this.vectorSource) return;

  // Clear existing features
  this.vectorSource.clear();

  // GeoJSON format parser
  const geoJsonFormat = new GeoJSON();

  // Add new polygon features
  const bounds: number[][] = [];
  this.latestMapInfo.forEach(info => {
    try {
      if (info.geoJson) {
          // Parse GeoJSON string
          const geoJson = JSON.parse(info.geoJson);
          const feature = geoJsonFormat.readFeature(geoJson, {
            dataProjection: 'EPSG:4326', // Assuming GeoJSON is in WGS84
            featureProjection: 'EPSG:3857' // Map projection
          });

         const properties = info.propertyGeoJson ? JSON.parse(info.propertyGeoJson) : {};
        feature.setProperties({
          apoSiteId: info.apoSiteId,
          apoId: info.apoId,
          formId: info.formId,
          componentId: info.componentId,
          name: properties.name || 'N/A',
          description: properties.description || '',
          area: properties.description?.match(/<td>Area<\/td>\s*<td>([\d.]+)<\/td>/)?.[1] || 'N/A'
        });

        // Apply styling based on geometry type
        if (geoJson.type === 'Polygon') {
          feature.setStyle(
            new Style({
              stroke: new Stroke({
                color: properties.stroke || 'red',
                width: 2,
                opacity: properties['stroke-opacity'] || 1
              }),
              fill: new Fill({
                color: `rgba(255, 255, 255, ${properties['fill-opacity'] || 0})`
              })
            })
          );
        } else if (geoJson.type === 'Point') {
          feature.setStyle(
            new Style({
              image: new Icon({
                src: '../assets/images/mapmarker.png'
              })
            })
          );
        } else if (geoJson.type === 'LineString') {
          feature.setStyle(
            new Style({
              stroke: new Stroke({
                color: properties.stroke || '#0000ff',
                width: 2,
                opacity: properties['stroke-opacity'] || 1
              })
            })
          );
        }
        // Add feature to vector source
        this.vectorSource.addFeature(feature);

        // Extend bounds for auto-zoom
        const extent = feature.getGeometry()?.getExtent();
        if (extent) {
          bounds.push(extent);
        }
      }
    } catch (error) {
      //console.error('Error parsing GeoJSON for info:', info, error);
    }
  });

  // Fit the map to the bounds of all features
  if (bounds.length > 0) {
    const view = this.olMap.getView();
    const extent = this.vectorSource.getExtent();
    view.fit(extent, {
      padding: [50, 50, 50, 50],
      maxZoom: 15,
      duration: 1000
    });
  }





    // this.latestMapInfo.forEach(info => {
    //   if (info.lat && info.lon) {
    //     const lat = parseFloat(info.lat);
    //     const lon = parseFloat(info.lon);
    //     if (isNaN(lat) || isNaN(lon)) return;

    //     // Create feature for the marker
    //    const feature = new Feature({
    //       geometry: new Point(proj.fromLonLat([lon, lat])),
    //       taskName: info.taskName,
    //       typeName: info.typeName,
    //       location: info.location,
    //       apoId:info.apoId,
    //       formId:info.formId,
    //       mapId:info.mapId,
    //       componentId:info.componentId
    //     });
    //    //feature.setProperties({ info: info });
    //     feature.setStyle(
    //       new Style({
    //         image: new Icon({
    //           src: '../assets/images/mapmarker.png',
    //         })
    //       })
    //     );
    //     this.vectorSource.addFeature(feature);

    //     // Add to bounds for auto-zoom
    //     bounds.push(proj.fromLonLat([lon, lat]));
    //   }
    // });

    // Fit the map to the bounds of all markers
    // if (bounds.length > 0) {
    //   const view = this.olMap.getView();
    //   const extent = this.vectorSource.getExtent();
    //   view.fit(extent, {
    //     padding: [50, 50, 50, 50],
    //     maxZoom: 10,
    //     duration: 1000
    //   });
    // }
  }
 private showPopup(coordinates: number[], properties: any, features: Feature[]): void {
    //console.log('Showing popup at coordinates:', coordinates, 'with properties:', properties);
    if (!this.popup) return;

     const content = document.getElementById('popup-content');
    if (content) {
      let popupHtml = `
        <div class="popup-header">
          <span class="popup-title">Feature Details</span>
          <button class="popup-close">×</button>
        </div>
        <div class="popup-content-body">
      `;

      features.forEach((feature, index) => {
        const props = {...feature.getProperties(),...properties};
        //console.log(props);
        
        popupHtml += `
          <div class="site-section">
            <h3>Site ${index + 1}</h3>
            <div class="section">
              <h4><i class="fas fa-info-circle"></i> APO Form Data</h4>
              <table class="table table-hover table-bordered popup-table">
                <tbody>
                  <tr>
                    <td><strong>Activity</strong></td>
                    <td>${props.taskName || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Item</strong></td>
                    <td>${props.typeName || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Location</strong></td>
                    <td>${props.location || 'N/A'}</td>
                  </tr>
                  ${props.quantity !== null || undefined ? `
                    <tr >
                      <td><strong>Quantity</strong></td>
                      <td>${props.quantity}</td>
                    </tr>
                  ` : ''}
                  ${props.unitCost !==  null || undefined  ? `
                    <tr>
                      <td><strong>Unit Cost</strong></td>
                      <td>${props.unitCost}</td>
                    </tr>
                  ` : ''}
                  ${props.amountRequired !==  null || undefined  ? `
                    <tr>
                      <td><strong>Amount Required</strong></td>
                      <td>${props.amountRequired}</td>
                    </tr>
                  ` : ''}
                </tbody>
              </table>
            </div>
            <div class="section">
              <h4><i class="fas fa-file-alt"></i> Supportive Documents</h4>
             <div class="document-links">
              ${props.apoMapSitesDocList && props.apoMapSitesDocList.length > 0
                ? props.apoMapSitesDocList
                    .map((doc: any) => {
                      const fullUrl = `${baseUrlFile}${doc.documentPath}`;
                      const isImage = doc.docType === 'Before Image' || doc.docType === 'After Image';
                      return `
                        <div class="document-item">
                          <div>
                            <strong>Type:</strong> ${doc.docType || 'N/A'}
                          </div>
                          <div>
                            <a href="${fullUrl}" target="_blank" class="doc-link">
                              <i class="fas fa-file"></i> ${doc.documentName || 'Unnamed Document'}
                            </a>
                          </div>
                          ${isImage ? `
                            <div class="image-preview">
                              <a href="${fullUrl}" target="_blank">
                                <img src="${fullUrl}" alt="${doc.documentName || 'Image Preview'}" style="max-width: 100px; max-height: 100px; margin-top: 5px;" />
                              </a>
                            </div>
                          ` : ''}
                          ${doc.latitude && doc.longitude ? `
                            <div>
                              <strong>Coordinates:</strong> Lat: ${doc.latitude}, Lon: ${doc.longitude}
                            </div>
                          ` : ''}
                          ${doc.propertyGeoJson ? (() => {
                              try {
                                const parsed = JSON.parse(doc.propertyGeoJson);
                                const areaMatch = parsed.description?.match(/<td>Area<\/td>\s*<td>([\d.]+)<\/td>/);
                                return `
                                  <div>
                                    <strong>Area:</strong> ${areaMatch?.[1] || 'N/A'} sq units
                                  </div>
                                `;
                              } catch (e) {
                                return `<div><strong>Area:</strong> Invalid GeoJSON</div>`;
                              }
                            })() : ''}
                        </div>
                      `;
                    })
                    .join('')
                : '<span>No Documents Available</span>'}
            </div>
          </div>
          <div class="section">
            <h4><i class="fas fa-comment"></i> Remarks</h4>
            <div class="remarks">
              ${props.apoMapSitesRemarksList && props.apoMapSitesRemarksList.length > 0
                ? props.apoMapSitesRemarksList
                    .map((remark: any, remarkIndex: number) => `
                      <div class="remark-item">
                        <strong>Remark ${remarkIndex + 1} (ID: ${remark.id}):</strong> ${remark.remarks || 'No Remarks'}
                      </div>
                    `)
                    .join('')
                : '<span>No Remarks Available</span>'}
            </div>
          </div>
        </div>
      `;
    });

      popupHtml += `</div>`;

     content.innerHTML = popupHtml;

    const popupElement = document.getElementById('popup');
    if (popupElement) {
      popupElement.style.display = 'block';
      popupElement.style.position = 'absolute';
      popupElement.style.left = 'auto';
      popupElement.style.top = 'auto';

      const header = popupElement.querySelector('.popup-header') as HTMLElement;
      let isDragging = false;
      let initialMapCoord: number[] = coordinates;

      // Define drag event handlers
      const onMouseDown = (e: MouseEvent) => {
        e.preventDefault(); // Prevent text selection or other default behaviors
        isDragging = true;
        const pixel = [e.clientX, e.clientY];
        initialMapCoord = this.olMap!.getCoordinateFromPixel(pixel) || coordinates;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      };

      const onMouseMove = (e: MouseEvent) => {
        if (isDragging) {
          const pixel = [e.clientX, e.clientY];
          let newMapCoord = this.olMap!.getCoordinateFromPixel(pixel);
          if (newMapCoord && !isNaN(newMapCoord[0]) && !isNaN(newMapCoord[1])) {
            // Clamp coordinates to map extent
            const mapExtent = this.olMap!.getView().calculateExtent(this.olMap!.getSize());
            newMapCoord[0] = Math.max(mapExtent[0], Math.min(mapExtent[2], newMapCoord[0]));
            newMapCoord[1] = Math.max(mapExtent[1], Math.min(mapExtent[3], newMapCoord[1]));
            this.popup!.setPosition(newMapCoord);
          }
        }
      };

      const onMouseUp = () => {
        isDragging = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      if (header) {
        header.style.cursor = 'move';
        header.removeEventListener('mousedown', onMouseDown); // Prevent duplicates
        header.addEventListener('mousedown', onMouseDown);
      }

      const closeButton = content.querySelector('.popup-close') as HTMLElement;
      if (closeButton) {
        const onClose = () => {
          popupElement.style.display = 'none';
          this.popup?.setPosition(undefined);
          header.removeEventListener('mousedown', onMouseDown);
          closeButton.removeEventListener('click', onClose);
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        };
        closeButton.removeEventListener('click', onClose); // Prevent duplicates
        closeButton.addEventListener('click', onClose);
      }

      // Set initial popup position
      this.popup.setPosition(coordinates);
     }
    }
  }




  //******************************************************************* */
 extractGpsCoordinates(): void {
  this.gpsCoordinates = [];
  const processTask = (task: any) => {
    if (task.apoValueResponse && task.apoValueResponse.gpsdd1 && task.apoValueResponse.gpsdd2) {
      const lat = this.convertDmsToDecimal(
        parseFloat(task.apoValueResponse.gpsdd1 || '0'),
        parseFloat(task.apoValueResponse.gpsmm1 || '0'),
        parseFloat(task.apoValueResponse.gpsss1 || '0')
      );
      const lng = this.convertDmsToDecimal(
        parseFloat(task.apoValueResponse.gpsdd2 || '0'),
        parseFloat(task.apoValueResponse.gpsmm2 || '0'),
        parseFloat(task.apoValueResponse.gpsss2 || '0')
      );
      if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
        this.gpsCoordinates.push({
          lat,
          lng,
          properties: {
            taskName: task.taskName,
            quantity: task.apoValueResponse.quantity,
            unitCost: task.apoValueResponse.unitCost,
            amountRequired: task.apoValueResponse.amountRequired,
            location: task.apoValueResponse.location,
            site: task.apoValueResponse.site
          }
        });
      } else {
        //console.warn('Invalid GPS coordinates for task:', task.taskId, 'lat:', lat, 'lng:', lng);
      }
    }
    if (task.subTaskList?.length) {
      task.subTaskList.forEach((subTask: any) => processTask(subTask));
    }
  };
  this.latestMapInfo.forEach((task: any) => processTask(task));
  //console.log('Extracted GPS coordinates:', this.gpsCoordinates);
}

convertDmsToDecimal(degrees: number, minutes: number, seconds: number): number {
  return degrees + (minutes / 60) + (seconds / 3600);
}
}
